/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { Api } from 'app/shared/lib/essette-api';
import { IApiActionResults } from 'app/shared/lib/api/api-types';
import { ApiDateTime } from 'app/shared/models/essette-api';
import * as Core from 'app/core/models/essette-api';

@autoinject()
export class TrackingService {

    ////****************** Functions ************************************************////
    constructor(private readonly api: Api) { }

    ////****************** Queries **************************************************////

    public async trackUsers(modelUrl: string, isTracked: boolean): Promise<ITrackActionResults> {
        const action = this.api.action('track', `${modelUrl}`, { tracking: { isTracked } });
        return await this.api.post(action);
    }

}

export interface ITrackedUser extends Core.User {
    tracking: {
        trackedTimestamp: ApiDateTime | null;
    }
}

export interface ITrackActionResult {
    timestamp?: string | null;
    users?: ITrackedUser[];
}

export interface ITrackActionResults extends IApiActionResults {
    result: ITrackActionResult;
}
